import React from "react";
import {

    Drawer, Form, Table as AntTable,
} from "antd";
import {useAppData} from "../../store/app-data";
import styled from "styled-components";
import {getNotificationColumns} from "./notification-columns";
import {getUserPromocodesColumns} from "./promocodes-columns";

export function UserPromocodesDrawer({
                            title,
                            onClose,
                            clearData,
                            items
                           }) {

    const layoutConfig = useAppData((state) => state.layoutConfig);

    const columns = getUserPromocodesColumns();

    const handleClose = () => {
        onClose();
        clearData();
    }

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "80%"}
            title={title}
            onClose={handleClose}
            open
        >
            <StyledTable
                dataSource={items}
                columns={columns}
                pagination={false}
            />
        </DrawerEdit>
    );
}

const DrawerEdit = styled(Drawer)``;

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
  .ant-table-row{
    background: #ffffff;
  }
  max-width: 100%;
  overflow: scroll;
`;